export const phoneNumbers = {
  workers_compensation: {
    display: "(855) 940-2484",
    href: "+18559402484",
  },
  usa: {
    display: "(855) 699-4041",
    href: "+18556994041",
  },
  business_owners_policy: {
    display: "(855) 467-7810",
    href: "+18554677810",
  },
};

export const getPhoneNumber = (vertical: string) => {
  return (
    phoneNumbers[vertical as keyof typeof phoneNumbers] ?? {
      display: "(855) 699-4041",
      href: "+18556994041",
    }
  );
};
